
import { toast } from "sonner";

/**
 * Função utilitária para lidar com operações de salvamento com tratamento de erros
 * para evitar telas brancas e outros problemas comuns
 */
export const handleSaveOperation = async (
  saveFunction: () => Promise<any>,
  successMessage: string = "Dados salvos com sucesso!",
  errorMessage: string = "Erro ao salvar dados"
): Promise<boolean> => {
  try {
    // Mostra um toast de carregamento
    const toastId = toast.loading("Salvando...");
    
    // Executa a função de salvamento
    await saveFunction();
    
    // Atualiza o toast para sucesso
    toast.success(successMessage, {
      id: toastId
    });
    
    return true;
  } catch (error) {
    console.error("Erro durante operação de salvamento:", error);
    
    // Mostra mensagem de erro
    toast.error(errorMessage);
    
    return false;
  }
};

/**
 * Função para prevenir navegação acidental durante o salvamento
 */
export const preventNavigationDuringSave = (
  isLoading: boolean,
  message: string = "Há uma operação em andamento. Tem certeza que deseja sair desta página?"
): (() => void) => {
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    if (isLoading) {
      event.preventDefault();
      event.returnValue = message;
      return message;
    }
  };
  
  window.addEventListener('beforeunload', handleBeforeUnload);
  
  // Retorna uma função de cleanup para remover o listener quando o componente desmontar
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
};
